//* react
import React from 'react';

interface UnreadUsersPreviewProps {
  viewId: 'my-chats' | 'not-my-chats' | 'unassigned-chats' | 'bots-chats' | 'chats' | undefined;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const UnreadUsersPreview: React.FC<UnreadUsersPreviewProps> = () => {
  // Component is kept empty as the API now returns only counts, not user lists
  return null;
};

export default UnreadUsersPreview;
